(() => {
  'use strict';
  /* PEERNEST_PASS2_ADMIN_EXCEPTIONS_V1 | requires installed Pass 2 backend */
  const escapeHTML = value => String(value ?? '')
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  const readableDate = value => {
    if (!value) return '—';
    const time = new Date(value);
    return Number.isNaN(time.getTime()) ? '—' : time.toLocaleString('en-IN',{dateStyle:'medium',timeStyle:'short'});
  };
  const rp = (name, body={}) => window.PeerNestDB.request(`rpc/${name}`,'',{method:'POST',body});
  const money = number => new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:2}).format(Number(number)||0);
  let cache = null;
  let busy = false;

  function formHTML(s) {
    const mentors = Array.isArray(s.mentors) ? s.mentors : [];
    const options = mentors.map((m,i)=> `<label class="pnx-field"><span>${escapeHTML(m.mentor_name)} · ${money(m.mentor_amount)} allocated</span>
      <select name="outcome_${i}" data-pnx-mentor="${escapeHTML(m.mentor_id)}" required>
        <option value="">Choose verified outcome</option>
        <option value="attended">Attended — eligible</option>
        <option value="student_no_show">Student absent — attending mentor eligible</option>
        <option value="mentor_no_show">Mentor absent — void earnings, offer free compensation</option>
      </select></label>`).join('');
    return `<article class="pnx-item"><div class="pnx-item-head"><div>
      <strong>${escapeHTML(s.student_name)} · ${escapeHTML(s.booking_type==='compare_live'?'Compare Live':'Individual mentoring')}</strong>
      <small>${escapeHTML(readableDate(s.starts_at))} · ${escapeHTML(s.booking_status)}</small>
      </div><span class="pnx-pill">Review evidence</span></div>
      <p class="pnx-muted">Join records are only indicators, not proof of attendance. Student: ${s.student_joined_at?'Join recorded':'No join recorded'} · Mentor: ${s.mentor_joined_at?'Join recorded':'No join recorded'}${s.booking_type==='compare_live'?' (booking-wide; verify each mentor separately)':''}.</p>
      <form data-pnx-review="${escapeHTML(s.booking_id)}">${options}
        <label class="pnx-field"><span>Evidence and decision notes (20–1200 characters)</span>
        <textarea rows="3" minlength="20" maxlength="1200" required placeholder="Describe verified attendance and the source of evidence, including any dispute."></textarea></label>
        <button class="pnx-button pnx-button--primary" type="submit">Record final review</button>
      </form></article>`;
  }
  function caseHTML(c) {
    const slots=Array.isArray(c.available_slots)?c.available_slots:[];
    const opts = slots.map(s=>`<option value="${escapeHTML(s.slot_id)}">${escapeHTML(readableDate(s.starts_at))}</option>`).join('');
    return `<article class="pnx-item"><div class="pnx-item-head"><div><strong>${escapeHTML(c.student_name)}</strong>
      <small>${escapeHTML(c.mentor_name)} · Original ${escapeHTML(readableDate(c.original_starts_at))}</small></div>
      <span class="pnx-pill">${escapeHTML(c.status)}</span></div>
      ${c.status==='owed' ? `<form data-pnx-schedule="${escapeHTML(c.original_booking_id)}" data-pnx-mentor="${escapeHTML(c.original_mentor_id)}">
        <label class="pnx-field"><span>Choose a real available 15-minute starting slot (30-min sessions reserve two)</span>
        <select required ${opts?'':'disabled'}><option value="">Choose available time</option>${opts}</select></label>
        ${opts?'<button type="submit" class="pnx-button pnx-button--primary">Schedule free replacement</button>':'<p class="pnx-muted">No available slots in next 45 days. Ask this mentor to open availability.</p>'}
      </form>`:`<p class="pnx-muted">Replacement booked for ${escapeHTML(readableDate(c.scheduled_at))}. Booking ID: ${escapeHTML(c.replacement_booking_id)}. No new payment or mentor earnings.</p>`}</article>`;
  }
  function render(target) {
    if (!target?.isConnected) return;
    const sessions = Array.isArray(cache?.exceptions)?cache.exceptions:[];
    const cases=Array.isArray(cache?.compensations)?cache.compensations:[];
    target.innerHTML = `<div class="pnx-workspace"><header class="pnx-head"><div><span class="pnx-overline">SESSION EXCEPTIONS</span>
      <h3>No-show reviews & free compensation</h3><p>Exception-only financial decisions. Normal successful sessions do not need Admin approval.</p>
      </div><button class="pnx-button" type="button" data-pnx-refresh>Refresh</button></header>
      <div class="pnx-metrics"><div><small>Sessions eligible for review</small><strong>${sessions.length}</strong></div>
      <div><small>Compensation cases</small><strong>${cases.length}</strong></div></div>
      <div class="pnx-message" role="status" aria-live="polite"></div>
      <details class="pnx-group"><summary>Review completed/past mentoring sessions <span>${sessions.length}</span></summary>
        <p class="pnx-muted">Decisions are permanent and may change payout eligibility. Verify evidence before submitting. Paid/reserved/voided cases require separate financial reconciliation and are not listed.</p>
        ${sessions.length?sessions.map(formHTML).join(''):'<div class="pnx-empty">No eligible unreviewed sessions.</div>'}</details>
      <details class="pnx-group" open><summary>Schedule owed free compensation <span>${cases.length}</span></summary>
      ${cases.length?cases.map(caseHTML).join(''):'<div class="pnx-empty">No compensation cases waiting for scheduling.</div>'}</details>
      <p class="pnx-muted">Scheduling costs ₹0; it does not create a payment, refund, payout, or second mentor earning. The mentor/student Join actions are still required.</p>
      </div>`;
    wire(target);
  }
  function message(target,txt,error=false) {
    const node=target.querySelector('.pnx-message');
    if (node) { node.textContent=txt;node.classList.toggle('pnx-error',error); }
  }
  async function refresh(target) {
    if (busy) return;
    busy=true;
    target.innerHTML='<div class="pnx-empty">Loading verified session exceptions…</div>';
    try {
      const response=await rp('pn_admin_pass2_workspace_v1');
      if (!response || !Array.isArray(response.exceptions)||!Array.isArray(response.compensations)) throw new Error('Invalid exception workspace response');
      cache=response; render(target);
    } catch(e) {
      target.innerHTML=`<div class="pnx-empty pnx-error">Could not load the exception workspace: ${escapeHTML(e?.message||'Unknown error')}. Confirm the read-only workspace RPC is installed in this project's backend. <button type="button" data-pnx-retry>Retry</button></div>`;
      target.querySelector('[data-pnx-retry]')?.addEventListener('click',()=>refresh(target));
    } finally { busy=false; }
  }
  function wire(target) {
    target.querySelector('[data-pnx-refresh]')?.addEventListener('click',()=>refresh(target));
    target.querySelectorAll('[data-pnx-review]').forEach(form=>form.addEventListener('submit',async e=>{
      e.preventDefault();if(busy) return;
      const selects=Array.from(form.querySelectorAll('[data-pnx-mentor]'));
      if(selects.some(s=>!s.value)) return message(target,'Select one verified outcome for each mentor.',true);
      const p_outcomes=Object.fromEntries(selects.map(s=>[s.dataset.pnxMentor,s.value]));
      const note=form.querySelector('textarea')?.value.trim()||'';
      if(note.length<20||note.length>1200)return message(target,'Write 20–1200 characters of verified evidence.',true);
      if(!window.confirm('Record this final attendance decision? It can change mentor dues and create a free compensation obligation. This cannot be undone in Admin.'))return;
      busy=true;const button=form.querySelector('[type=submit]');button.disabled=true;
      try {await rp('pn_admin_resolve_session_exception_v1',{p_booking_id:form.dataset.pnxReview,p_outcomes,p_evidence_note:note});
        await rp('pn_admin_pass2_workspace_v1').then(v=>{cache=v;render(target)});
        message(target,'Final review recorded. Check compensation cases and refreshed dues.');
      } catch(err){button.disabled=false;message(target,err?.message||'Review failed. No confirmation received.',true)}finally{busy=false}
    }));
    target.querySelectorAll('[data-pnx-schedule]').forEach(form=>form.addEventListener('submit',async e=>{
      e.preventDefault();if(busy)return;
      const slot=form.querySelector('select')?.value;
      if(!slot)return message(target,'Choose a free starting slot.',true);
      if(!window.confirm('Schedule a ₹0 replacement with the same mentor? No payment or extra earnings will be created.'))return;
      busy=true;const button=form.querySelector('[type=submit]');button.disabled=true;
      try {await rp('pn_admin_schedule_compensation_v1',{p_original_booking_id:form.dataset.pnxSchedule,p_original_mentor_id:form.dataset.pnxMentor,p_slot_id:slot});
        await rp('pn_admin_pass2_workspace_v1').then(v=>{cache=v;render(target)});
        message(target,'Free replacement booked. Ask student and mentor to check their session dashboards.');
      }catch(err){button.disabled=false;message(target,err?.message||'Scheduling failed. Refresh available slots.',true)}finally{busy=false}
    }));
  }
  window.PeerNestPass2Exceptions={mount(target){ if (!target) return;
    if (target.dataset.pnxMounted==='yes') return;
    target.dataset.pnxMounted='yes'; refresh(target);
  }};
})();
